import { useNavigationContext } from '../context';
export function useIsEmployerApp() {
  var _router$asPath;

  var _useNavigationContext = useNavigationContext(),
      router = _useNavigationContext.router;

  var isEmployerApp = !!(router !== null && router !== void 0 && (_router$asPath = router.asPath) !== null && _router$asPath !== void 0 && _router$asPath.includes('/employer'));
  return {
    isEmployerApp: isEmployerApp
  };
}